module.exports = __webpack_public_path__ + "site/img/Maps_1LongPing.728271a8.jpg";